// Navegação por hash (useHash: true): alterar location.hash dispara o HashRouter
// do shell React, sem acoplar o view-model ao contexto de roteamento.

/** Navega para `path` reagindo apenas ao HashRouter do shell, sem depender de nenhum router. */
export function navigateToRoute(path: string): void {
  window.location.hash = `#${path}`;
}
